// @ts-nocheck
import { useBunzlDispatch } from "@store/Framework/Store/Bunzl/BunzlReducer";
import { validationErrorSelector } from "@store/Framework/Store/Bunzl/Pages/Reporting/ReportApi/ReportAPISelectors";
import { useSelector } from "react-redux";

export const useValidationError = () => {
    const dispatch = useBunzlDispatch();
    const validationError = useSelector(validationErrorSelector);

    const setValidationError = (error: boolean) => {
        dispatch({
            type: "Store/Pages/reportAPI/setValidationError",
            action: error,
        });
    };
    return [validationError, setValidationError] as const;
};
